import Keycloak from 'keycloak-js';
import env from './env';

// Only create Keycloak instance if we're using Keycloak auth
const useKeycloakAuth = env.useKeycloakAuth;

const keycloakConfig = {
    url: env.keycloak.baseUrl,
    realm: env.keycloak.realm,
    clientId: env.keycloak.clientId
};

// Create a mock Keycloak instance when not using Keycloak auth
const mockKeycloak = {
    init: () => Promise.resolve(false),
    login: () => {},
    logout: () => {},
    token: null,
    tokenParsed: null,
    hasRealmRole: () => false
};

const keycloak = useKeycloakAuth ? new Keycloak(keycloakConfig) : mockKeycloak;

export default keycloak; 